if (!customElements.get('vdr-video')) {
  customElements.define('vdr-video', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const trigger = this.querySelector('.vdr-video-trigger');
      if (!trigger || !/^[A-Za-z0-9_-]{11}$/.test(this.dataset.videoId || '')) return;
      this.dataset.ready = 'true';
      trigger.setAttribute('role', 'button');
      trigger.addEventListener('keydown', event => {
        if (event.key === ' ') { event.preventDefault(); trigger.click(); }
      });
      trigger.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        // Load the external player only after an intentional play action.
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${this.dataset.videoId}?autoplay=1&rel=0`;
        iframe.title = this.dataset.title || 'YouTube';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        this.replaceChildren(iframe);
        iframe.focus();
      });
    }
  });
}
